<div class="row">
    <div class="col-3"></div>
    <div class="col-6">
        <p class="text-center alert-warning">{{place}} {{dateString}}</p>       
    </div>
</div>
<app-heb-units [hebrewDate]="hebrewDate"></app-heb-units>
